<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn :to="'/progress/' + user.uid + '/' + progress.key" color="error" exact icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">Tests</v-toolbar-title>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="pt-2" xs12>
      <div class="text-xs-center headline">{{progress.name + ' for ' + user.displayName}}</div>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 sm10>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else class="py-3 px-2" row wrap justify-center>
        <v-flex v-if="progress.length == 0" class="py-5" xs12>
          <div class="text-xs-center display-3 grey--text text--lighten-1">
            No Tasks
          </div>
        </v-flex>
        <v-flex v-else class="px-2 pb-3" xs12 md10>
          <v-expansion-panel class="elevation-0">
            <v-expansion-panel-content class="mb-3" v-for="(t, i) in tasks" :key="i">
              <div slot="header">
                <div class="title secondary--text">
                  <span><b>{{t.name}}</b></span>
                  <v-icon v-if="t.complete" class="ml-2 mb-2" color="success">done</v-icon>
                </div>
              </div>
              <v-layout row wrap>
                <v-flex v-if="t.attempts" class="pb-1 pl-4 mx-3" xs12>
                  <div class="pl-2"><b>Attempts</b></div>
                  <div v-if="t.attempts.length == 0" class="pl-2 my-3 headline grey--text text--lighten-2">None</div>
                  <v-list v-else class="pt-0">
                    <v-list-tile v-for="(attempt, j) in t.attempts" :key="j" @click="showAttemptDetails(attempt)">
                      <v-layout class="px-1" row wrap justify-center>
                        <v-flex class="text-xs-left" xs1>{{t.attempts.length - j}}</v-flex>
                        <v-flex class="text-xs-left" xs10>{{(new Date(attempt.startTime)).toLocaleString()}}</v-flex>
                        <v-flex class="text-xs-right" xs1>
                          <span
                            v-if="now < attempt.endTime"
                            class="grey--text"
                          ><b>--%</b></span>
                          <span
                            v-else-if="attempt.grade >= passGrade(t)"
                            class="success--text"
                          ><b>{{attempt.grade + '%'}}</b></span>
                          <span
                            v-else-if="attempt.grade >= almostPassGrade(t)"
                            class="accent--text"
                          ><b>{{attempt.grade + '%'}}</b></span>
                          <span
                            v-else
                            class="error--text"
                          ><b>{{attempt.grade + '%'}}</b></span>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>

  <r-progress-popup :popup="popup" :taskProgress="currentAttempt"></r-progress-popup>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
import ProgressPopup from './ProgressPopup.vue'
export default {
  components: {
    rCrumbs: Crumbs,
    rProgressPopup: ProgressPopup
  },
  data: () => ({
    loading: false,
    user: {},
    progress: {},
    tasks: [],
    currentAttempt: {},
    popup: {
      show: false,
      type: ''
    }
  }),
  computed: {
    now () {
      return this.$store.getters.now
    }
  },
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.user = this.$store.getters.userById(this.$route.params.uid)
      this.progress = this.$store.getters.progressByKey(this.$route.params.progressKey)
      let entry = {}
      let taskProgress = null
      this.$store.dispatch('loadTaskProgress', this.user.uid).then(() => {
        for (let t of this.$store.getters.taskBySection(this.$route.params.sectionKey)) {
          taskProgress = this.$store.getters.taskProgressByTaskByProgress(t.key, this.progress.key)
          entry = {
            ...t,
            complete: taskProgress ? taskProgress.complete : false,
            attempts: undefined
          }
          if (taskProgress) entry.complete = taskProgress.endTime ? (this.now > taskProgress.endTime) : entry.complete
          if (this.isTest(t)) {
            entry.attempts = this.$store.getters.testAttempts(t.key, this.progress.key)
            entry.attempts.reverse()
          }
          this.tasks.push(entry)
          this.tasks.sort((a, b) => {
            return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'})
          })
        }
        this.loading = false
      })
    },
    isTest (t) {
      let task = {...t}
      if (task.type === 'Linking') {
        task = this.$store.getters.taskByKey(task.linkedTaskKey)
      }
      return task.type === 'Practice' || task.type === 'NCLEX'
    },
    showAttemptDetails (attempt) {
      this.popup = {
        show: true,
        type: 'Attempt Details'
      }
      this.currentAttempt = attempt
    },
    passGrade (task) {
      const t = task.type === 'Linking' ? this.$store.getters.taskByKey(task.linkedTaskKey) : task
      return t ? t.passGrade || 65 : 65
    },
    almostPassGrade (task) {
      return Math.floor(this.passGrade(task) - (this.passGrade(task) * 0.2))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/progress/StudentTaskList.vue